var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    ref: "ConsentDialog",
    staticClass: "consent-dialog",
    attrs: {
      visible: _vm.showModal,
      size: "small",
      title: _vm.$t.__("sellsyadmin.ConnectionConsentDialog.access_request"),
      closeOnClickOverlay: false
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: _vm.closeModal
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c(
              "CompassRadioGroup",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.demandType === "service",
                    expression: "demandType === 'service'"
                  }
                ],
                staticClass: "radiogroup-consent",
                attrs: {
                  label: _vm.$t.__(
                    "sellsyadmin.ConnectionConsentDialog.request_type"
                  ),
                  direction: "horizontal",
                  size: "medium"
                },
                model: {
                  value: _vm.authorization,
                  callback: function($$v) {
                    _vm.authorization = $$v
                  },
                  expression: "authorization"
                }
              },
              [
                _c("CompassRadio", {
                  attrs: {
                    modelValue: "service",
                    label: _vm.$t.__(
                      "sellsyadmin.ConnectionConsentDialog.services"
                    )
                  }
                }),
                _vm._v(" "),
                _c("CompassRadio", {
                  attrs: {
                    modelValue: "support",
                    label: _vm.$t.__(
                      "sellsyadmin.ConnectionConsentDialog.support"
                    )
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "CompassFormItem",
              {
                staticClass: "select-collaborator",
                attrs: { label: "Collaborateur" }
              },
              [
                _c(
                  "CompassSelect",
                  {
                    attrs: {
                      size: "medium",
                      placeholder: _vm.$t.__("common.actions.select_staff"),
                      filterable: "",
                      menuClass: "staff-selector",
                      disabled: _vm.disabledSelect
                    },
                    model: {
                      value: _vm.selectedStaff,
                      callback: function($$v) {
                        _vm.selectedStaff = $$v
                      },
                      expression: "selectedStaff"
                    }
                  },
                  [
                    !_vm.filteredStaff.inactive.length
                      ? _c("CompassDropdownSelectOption", {
                          attrs: {
                            value: "no staff",
                            label: _vm.$t.__(
                              "sellsyadmin.ConnectionConsentDialog.no_staff_available"
                            )
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filteredStaff.pending.length > 0
                      ? _c(
                          "CompassOptionGroup",
                          {
                            attrs: {
                              label: _vm.$t.__(
                                "common.labels.access_awaiting_authorization"
                              )
                            }
                          },
                          _vm._l(_vm.filteredStaff.pending, function(option) {
                            return _c("CompassDropdownSelectOption", {
                              key: option.staffid,
                              attrs: {
                                value: option.staffid,
                                label: option.fullName,
                                labelCaption: _vm.labelCaptionStaffID(
                                  option.staffid
                                ),
                                avatar: option.avatar,
                                type: "avatar",
                                disabled: true
                              }
                            })
                          }),
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filteredStaff.inactive.length > 0
                      ? _c(
                          "CompassOptionGroup",
                          _vm._l(_vm.filteredStaff.inactive, function(option) {
                            return _c("CompassDropdownSelectOption", {
                              key: option.staffid,
                              attrs: {
                                value: option.staffid,
                                label: option.fullName,
                                labelCaption: _vm.labelCaptionStaffID(
                                  option.staffid
                                ),
                                avatar: option.avatar,
                                type: "avatar"
                              }
                            })
                          }),
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "CompassRadioGroup",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.demandType === "support",
                    expression: "demandType === 'support'"
                  }
                ],
                staticClass: "radiogroup-consent",
                attrs: {
                  label: _vm.$t.__(
                    "sellsyadmin.ConnectionConsentDialog.request_origin"
                  ),
                  direction: "horizontal",
                  size: "medium"
                },
                model: {
                  value: _vm.source,
                  callback: function($$v) {
                    _vm.source = $$v
                  },
                  expression: "source"
                }
              },
              [
                _c("CompassRadio", {
                  attrs: {
                    modelValue: "intercom",
                    label: _vm.$t.__(
                      "sellsyadmin.ConnectionConsentDialog.intercom"
                    )
                  }
                }),
                _vm._v(" "),
                _c("CompassRadio", {
                  attrs: {
                    modelValue: "sellsy",
                    label: _vm.$t.__(
                      "sellsyadmin.ConnectionConsentDialog.admin"
                    )
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "CompassFormItem",
              {
                attrs: {
                  label: _vm.customMessageTranslate.label,
                  info: _vm.getInfoCustomMessage,
                  error: _vm.getErrorCustomMessage
                }
              },
              [
                _c("CompassInput", {
                  attrs: {
                    type: "textarea",
                    placeholder: _vm.customMessageTranslate.placeholder,
                    error: _vm.exceedsLimit
                  },
                  model: {
                    value: _vm.customMessage,
                    callback: function($$v) {
                      _vm.customMessage = $$v
                    },
                    expression: "customMessage"
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.cancel"),
                    type: "secondary"
                  },
                  on: { click: _vm.closeModal }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.send"),
                    disabled: _vm.disableFormElements,
                    loading: _vm.loading
                  },
                  on: { click: _vm.handleRequest }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }